import { render, staticRenderFns } from "./btn-1.vue?vue&type=template&id=d3eccbbc&scoped=true&"
import script from "./btn-1.vue?vue&type=script&lang=js&"
export * from "./btn-1.vue?vue&type=script&lang=js&"
import style0 from "./btn-1.vue?vue&type=style&index=0&id=d3eccbbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3eccbbc",
  null
  
)

export default component.exports